import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';

import { useConversationQueryCache } from '@web/conversations/hooks/useConversationQueryCache';

export const useArchiveConversation = () => {
  const { archiveConversation } = useConversationQueryCache();
  const { conversation } = useSlingApi();

  const mutation = useMutation({
    mutationFn: async (payload: IDObject) => {
      const { data } = await conversation.archive(payload.id);

      return data;
    },
    onSuccess: (message) => {
      archiveConversation(message.id);
    },
  });

  return mutation;
};
